import * as angular from 'angular';
import { SharedUiModule } from '~/modules/shared-ui/shared-ui.module';

import { CopyToClipboardFieldComponent } from './copy-to-clipboard-field.component';

export const CopyToClipboardFieldModule = angular
  .module('copy-to-clipboard-field', [SharedUiModule])
  .component('copyToClipboardField', CopyToClipboardFieldComponent).name;
